const processInclude = require('./util');

$(document).ready(() => {
    processInclude(require('./storeLocator/storeLocator'));
});
